import config from "@/config";
import Axios from "@/utils/Axios";

// 查询付款订单详情
export function getOrderMemberDetail(data: { query_code?: string }) {
  return Axios.post(
    "/v1/order/detail",
    {
      query_code: data.query_code,
    },
    {},
    config.creatorUrl,
  );
}
